module.exports = __webpack_public_path__ + "static/energy_5-f2ceca3e76b23d38b9b5679f34085e04.jpg";